import { render, staticRenderFns } from "./AcceptReject.vue?vue&type=template&id=5e7d3b45&scoped=true&"
import script from "./AcceptReject.vue?vue&type=script&lang=js&"
export * from "./AcceptReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d3b45",
  null
  
)

export default component.exports